import { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../../App.context';
import { ApiContext } from '../../../utils/networking/Api.context';
import { notification } from 'antd';

export default function useSftpHook() {
  const { API } = useContext(ApiContext);
  const {
    appState,
    appActions: { translate, getSelectedHotel },
  } = useContext(AppContext);

  const [state, setState] = useState({
    subscription: false,
    isLoading: false,
    ftpHost: '',
    ftpProtocol: 'sftp',
    ftpPort: '',
    ftpUser: '',
    ftpPass: '',
    connectionErrorMessage: '',
  });

  useEffect(() => {
    if (!state.subscription) return;
    const fetchData = async () => {
      await actions.getSftpConfig();
    };
    fetchData();
  }, [appState.selectedHotel, state.subscription]);

  useEffect(() => {
    const fetchData = async () => {
      await actions.getHotelSubscription();
    };
    fetchData();
  }, [appState.selectedHotel]);

  const actions = {
    getHotelSubscription: async () => {
      const hotelId = getSelectedHotel().key;

      try {
        const response = await API.getAccountActiveFunctionalities([hotelId]);
        const module = response?.find(item => item.name === 'checkin_sftp');
        if (module && module?.active) {
          updateState({ subscription: true });
        }
      } catch (error) {}
    },

    getSftpConfig: async () => {
      updateState({ isLoading: true });
      const hotelId = getSelectedHotel().key;

      try {
        const response = await API.getSftpConfig(hotelId);

        updateState({
          ftpHost: response?.host,
          ftpProtocol: response?.protocol,
          ftpPort: response?.port,
          ftpUser: response.user,
          ftpPass: response?.password,
          isLoading: false,
        });
      } catch (error) {}
    },

    onSavePressed: async applyToAll => {
      updateState({ isLoading: true });

      let hotelId = null;
      if (!applyToAll) {
        hotelId = getSelectedHotel().key;
      }
      const body = {
        host: state.ftpHost,
        port: state.ftpPort,
        protocol: state.ftpProtocol,
        user: state.ftpUser,
        password: state.ftpPass,
        hotelId,
      };
      try {
        await API.updateSftpConfig(body);
        notification.success({
          message: translate('sftp.saveOk'),
        });
        await actions.checkConnections();
      } catch (error) {
        notification.error({
          message: translate('sftp.saveError'),
        });
      }
      updateState({ isLoading: false });
    },

    checkConnections: async () => {
      updateState({ isLoading: true });

      const body = {
        host: state.ftpHost,
        port: state.ftpPort,
        protocol: state.ftpProtocol,
        user: state.ftpUser,
        password: state.ftpPass,
      };
      try {
        await API.checkSftpConnection(body);
        notification.success({
          message: translate('sftp.connectionOk'),
        });
        updateState({ isLoading: false, connectionErrorMessage: '' });
      } catch (error) {
        notification.error({
          message: translate('sftp.connectionError'),
        });
        updateState({
          isLoading: false,
          connectionErrorMessage: error?.response?.data?.message || '',
        });
      }
    },

    setField: (fieldKey, value) => {
      updateState({ [fieldKey]: value });
    },
  };

  function updateState(object) {
    setState(prev => ({ ...prev, ...object }));
  }

  return { state, actions };
}
